import { Collapse, Input } from "antd";
import { useAppSelector } from "../../../app/store";
import SearchIcon from "../../../assets/icons/SearchIcon";
import CollapsePlusIcon from "../../../components/common/CollapsePlusIcon";
import CollapseRemoveIcon from "../../../components/common/CollapseRemoveIcon";
import TitleBar from "../../../components/common/TitleBar";
import CustomEmpty from "../../../components/ui/CustomEmpty";
import CustomPagination from "../../../components/ui/CustomPagination";
import Loader from "../../../components/ui/Loader";
import colors from "../../../constants/colors";
import { GetAllJobPostParamsType } from "../../../features/organization/job/job.type";
import { useGetAllJobPostQuery } from "../../../features/organization/job/jobApi";
import useError from "../../../hooks/useError";
import useTable from "../../../hooks/useTable";
import SidebarLayout from "../../../layouts/SidebarLayout";
import ProjectLabel from "./_components/ProjectLabel";
import ProjectUserList from "./_components/ProjectUserList";

export default function MyProjectList() {
  const { user } = useAppSelector((state) => state.auth);
  const { page, limit, keyword, filter, handlePagination, handleSearch } =
    useTable<GetAllJobPostParamsType>();
  const { isError, error, data, isLoading, isFetching } = useGetAllJobPostQuery(
    {
      params: {
        ...filter,
        search: keyword,
        business_id: user?.business_id,
        for: "project",
        for_web_proposal: "not_deleted",
      },
    }
  );
  // const statusList = jobStatusList.map((status) => {
  //   const { className, ...rest } = status;
  //   return rest.value === "posted"
  //     ? {
  //         ...rest,
  //         label: "Published",
  //       }
  //     : rest;
  // });
  useError(isError, error, "Projects get fail");

  return (
    <SidebarLayout title="My Projects">
      <TitleBar title="Project List" className="small-input-section">
        <div className="flex items-center gap-3">
          <Input
            suffix={<SearchIcon />}
            placeholder="Search by Job ID and Name"
            style={{ minWidth: 170 }}
            onChange={(val) => handleSearch(val)}
          />
          {/* <Select
            allowClear
            showSearch
            placeholder="All Bondhu"
            filterOption={selectSearchOption}
            options={selectStringOption(["all"], "string", true)}
            className="min-w-[70px]"
            suffixIcon={<SelectDownIcon />}
            rootClassName="icon-gray"
            // value={filter.status}
            // onChange={(val) => handleFilter("status", val)}
          />
          <Select
            allowClear
            showSearch
            placeholder="Active Projects"
            filterOption={selectSearchOption}
            options={selectStringOption(["all"], "string", true)}
            className="min-w-[70px]"
            suffixIcon={<SelectDownIcon />}
            rootClassName="icon-gray"
            // value={filter.status}
            // onChange={(val) => handleFilter("status", val)}
          /> */}
        </div>
      </TitleBar>

      {isLoading || isFetching ? (
        <Loader />
      ) : data?.data?.jobs?.length ? (
        <div className="overflow-x-auto">
          <div className="min-w-[1150px]">
            <Collapse
              rootClassName="proposal-collapse"
              className="border-transparent bg-transparent"
              items={data?.data?.jobs?.map((job) => ({
                key: job?.id,
                label: <ProjectLabel data={job} />,
                children: <ProjectUserList id={job?.id} />,
              }))}
              expandIconPosition="end"
              expandIcon={({ isActive }) => (
                <span
                  className={`transition-all ${isActive ? "rotate-180" : ""}`}
                >
                  {isActive ? (
                    <CollapseRemoveIcon color={colors.danger.color} />
                  ) : (
                    <CollapsePlusIcon color={colors.primary} />
                  )}
                </span>
              )}
            />
          </div>

          <CustomPagination
            total={Number(data?.data?.total)}
            limit={limit}
            page={page}
            handlePagination={handlePagination}
          />
        </div>
      ) : (
        <CustomEmpty
          rootClassName="flex justify-center items-center rounded-md min-h-[calc(100vh-170px)] !mx-0"
          styles={{ image: { height: 100 } }}
        />
      )}
    </SidebarLayout>
  );
}
